<template>
  <div
    class="ani-stage-card"
    :class="_classObj"
  >
    <slot :state="resolveState"/>
  </div>
</template>

<script>
  import { STATE_RESOLVED, STATE_RESOLVING } from './helpers'

  export default {
    name: 'AniStageCard',

    props: {
      pending: {
        type: Boolean,
        default: false,
      },

      active: {
        type: Boolean,
        default: false
      },

      vwSize: {
        type: Object,
        required: true
      },

      idx: {
        type: Number
      },

      supportAnimation: {
        type: Boolean
      }
    },

    data () {
      return {
        resolveState: false
      }
    },

    created () {
      this.$watch('active', (a) => {
        if (a) {
          this.resolveState = STATE_RESOLVING
        } else {
          if (this.isResolving) {
            this.resolveState = STATE_RESOLVED
          }
        }
      }, {
        immediate: true
      })
    },

    computed: {
      _classObj () {
        const obj = {}

        if (this.pending) {
          obj.pending = true
        }

        if (this.resolveState) {
          obj[`${this.resolveState}`] = true
        }

        obj[`card-index-${this.idx}`] = true

        return obj
      },

      isResolving () {
        return this.resolveState === STATE_RESOLVING
      },

      isResolved () {
        return this.resolveState === STATE_RESOLVED
      }
    }
  }
</script>
